import React, { FC, useCallback } from 'react'
import { cn } from 'shared/utils'
import { useController } from 'react-hook-form'
import { InputGroup, Select } from '@wmgtech/legato'

import { TSelectOption } from 'shared/types'
import { isRequired } from 'shared/utils/form'

import { FormSelectProps } from './FormSelect.props'
import './FormSelect.scss'

const FormSelect: FC<FormSelectProps> = ({
  label = '',
  control,
  fieldName,
  rules,
  dataTest,
  disabled,
  placeholder,
  className,
  options,
  autoComplete = 'off',
  isClearable,
}) => {
  const {
    field: { ref, ...restField },
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
    rules
  })

  const handleChange = useCallback(
    (el?: TSelectOption) => {
      if (typeof el === 'undefined') {
        restField.onChange('')
      } else {
        restField.onChange(el.value)
      }
    },
    [restField],
  )

  return (
    <InputGroup
      label={label}
      className={cn('form-input-group', className, { 'form-input-group__error': error })}
      labelProps={{ icon: isRequired(rules) && label ? 'asterisk' : undefined }}
      validation={{
        message: error?.message,
        ...(error && { type: 'error' })
      }}
    >
      <Select<TSelectOption>
        className="form-select"
        list={options}
        disabled={disabled}
        data-test={dataTest}
        placeholder={placeholder}
        getKey={el => el.value}
        getTitle={el => el.label}
        onSelect={handleChange}
        autoComplete={autoComplete}
        inputRef={ref}
        isClearable={isClearable}
        {...restField}
      />
    </InputGroup>
  )
}

export default FormSelect
